import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useState, useContext } from "react";
import { RouteComponentProps, useHistory } from "react-router-dom";
import Button from "../components/Button";
import { ButtonContainer } from "../components/ButtonContainer";
import CenterContainer from "../components/CenterContainer";
import { AnyListener, useForm } from "typed-react-form";
import { Form, FormCheck, FormLabel, FormRow } from "../components/FormElements";
import Title from "../components/Title";
import { useLanguage } from "../useLanguage";
import AuthContext from "../AuthContext";

interface EmailPreferences {
    enableEmail: boolean;
    enableNotificationEmail: boolean;
}

export function EmailPreferenceForm(props: { cancel: () => void; submit: (p: EmailPreferences) => Promise<void>; values: EmailPreferences }) {
    const form = useForm(props.values);
    const language = useLanguage();

    useEffect(() => {
        form.setDefaultValues(props.values);
    }, [props.values]);

    async function submit() {
        form.setState({ isSubmitting: true });
        await props.submit(form.values);
        form.setState({ isSubmitting: false });
    }

    return (
        <CenterContainer width="500px" style={{ margin: "2em 0" }}>
            <Title>{language("email-preference")}</Title>
            <Form
                onSubmit={(ev) => {
                    ev.preventDefault();
                    submit();
                }}>
                <p>{language("email-preference-info")}</p>
                <FormRow>
                    <FormLabel>{language("email-preference-new-tests")}</FormLabel>
                    <FormCheck form={form} name="enableEmail" />
                </FormRow>
                <FormRow>
                    <FormLabel>{language("email-preference-notifications")}</FormLabel>
                    <FormCheck form={form} name="enableNotificationEmail" />
                </FormRow>
                <hr />
                <ButtonContainer>
                    <Button type="button" color="#666" icon={faTimes} onClick={props.cancel}>
                        {language("email-preference-cancel")}
                    </Button>
                    <AnyListener
                        form={form}
                        render={({ state, error, dirty }) => (
                            <Button disabled={state.isSubmitting} loading={state.isSubmitting} type="submit" icon={faCheck} color="#56a44f">
                                {language("email-preference-save")}
                            </Button>
                        )}
                    />
                </ButtonContainer>
            </Form>
        </CenterContainer>
    );
}

export function EmailPreference(props: RouteComponentProps<{ s: string }>) {
    const [values, setValues] = useState<EmailPreferences>({ enableEmail: false, enableNotificationEmail: false });
    const token = decodeURIComponent(props.match.params.s);
    const history = useHistory();
    const { client } = useContext(AuthContext);

    useEffect(() => {
        (async () => {
            let res = await client.fetch("/user/emailpreference", { token });
            setValues({
                enableEmail: res.enableEmail,
                enableNotificationEmail: res.enableNotificationEmail,
            });
        })();
    }, []);

    async function submit(values: EmailPreferences) {
        await client.fetch("/user/emailpreference/update", {
            token,
            enableEmail: values.enableEmail,
            enableNotificationEmail: values.enableNotificationEmail,
        });
        history.push("/");
    }

    return <EmailPreferenceForm cancel={() => history.push("/")} submit={submit} values={values} />;
}
